import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  Collapse,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from '@mui/material';
import { motion } from 'framer-motion';
const trendingCourses = [
  {
    title: 'C Programming',
    description: 'Basics, Functions, Arrays, Pointers',
    category: 'Programming',
    link: '#',
    details: {
      topics: ['Variables', 'Control Flow', 'Functions', 'Arrays', 'Pointers'],
      duration: '6 weeks',
      prerequisites: 'None',
      learningOutcome: 'Understand the fundamentals of C, memory management, and structured programming.'
    }
  },
  {
    title: 'C++ Programming',
    description: 'OOPs, STL, Memory Management',
    category: 'Programming',
    link: '#',
    details: {
      topics: ['Classes', 'Inheritance', 'STL', 'Dynamic Memory'],
      duration: '6 weeks',
      prerequisites: 'C Programming',
      learningOutcome: 'Build efficient OOP-based applications using C++.'
    }
  },
  {
    title: 'Java Programming',
    description: 'OOPs, JDBC, Collections',
    category: 'Programming',
    link: '#',
    details: {
      topics: ['OOPs Concepts', 'Java Collections', 'JDBC'],
      duration: '6 weeks',
      prerequisites: 'Basic Programming',
      learningOutcome: 'Develop console and database-connected applications.'
    }
  },
  {
    title: 'Python Programming',
    description: 'Scripting, OOPs, File I/O',
    category: 'Programming',
    link: '#',
    details: {
      topics: ['Syntax', 'OOPs', 'File Handling', 'Libraries'],
      duration: '5 weeks',
      prerequisites: 'None',
      learningOutcome: 'Write efficient Python scripts and basic applications.'
    }
  },
  {
    title: 'JavaScript',
    description: 'DOM, ES6+, Async/Await',
    category: 'Programming',
    link: '#',
    details: {
      topics: ['Variables', 'DOM', 'ES6', 'Promises'],
      duration: '5 weeks',
      prerequisites: 'HTML, CSS',
      learningOutcome: 'Create dynamic and interactive web pages.'
    }
  },
  {
    title: 'Embedded C',
    description: 'Microcontroller Programming & Peripherals',
    category: 'Embedded',
    link: '#',
    details: {
      topics: ['8051/AVR', 'Timers', 'Interrupts'],
      duration: '6 weeks',
      prerequisites: 'C Programming',
      learningOutcome: 'Build firmware for embedded systems.'
    }
  },
  {
    title: 'Python for ML & AI',
    description: 'NumPy, Pandas, Scikit-learn',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['NumPy', 'Pandas', 'Data Cleaning', 'ML Models', 'Evaluation Metrics'],
      duration: '6 weeks',
      prerequisites: 'Basic Python',
      learningOutcome: 'Build basic machine learning models and analyze data efficiently.'
    }
  },
  {
    title: 'Deep Learning',
    description: 'TensorFlow, PyTorch, OpenCV',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['Neural Networks', 'CNN', 'Image Processing'],
      duration: '6 weeks',
      prerequisites: 'Python for ML',
      learningOutcome: 'Train and test deep learning models for vision tasks.'
    }
  },
  {
    title: 'Computer Vision',
    description: 'Image Classification, YOLO, Face Recognition',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['OpenCV', 'YOLOv5', 'Image Augmentation'],
      duration: '6 weeks',
      prerequisites: 'Deep Learning',
      learningOutcome: 'Implement real-time vision-based systems.'
    }
  },
  {
    title: 'NLP & ChatGPT',
    description: 'Transformers, HuggingFace, ChatGPT',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['Text Preprocessing', 'Transformers', 'ChatGPT API'],
      duration: '5 weeks',
      prerequisites: 'Python for ML',
      learningOutcome: 'Build applications using large language models.'
    }
  },
  {
    title: 'Generative AI',
    description: 'ChatGPT, DALL·E, Midjourney, LangChain',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['LLMs', 'LangChain', 'Prompting'],
      duration: '4 weeks',
      prerequisites: 'NLP or Deep Learning',
      learningOutcome: 'Build generative apps using AI APIs.'
    }
  },
  {
    title: 'MLOps',
    description: 'Model deployment with FastAPI & Docker',
    category: 'AI/ML',
    link: '#',
    details: {
      topics: ['CI/CD', 'Docker', 'FastAPI', 'Model Registry'],
      duration: '5 weeks',
      prerequisites: 'ML Basics',
      learningOutcome: 'Deploy and monitor ML models in production.'
    }
  },
  {
    title: 'MERN Stack',
    description: 'MongoDB, Express, React, Node.js',
    category: 'Web',
    link: '#',
    details: {
      topics: ['CRUD', 'REST APIs', 'State Management'],
      duration: '6 weeks',
      prerequisites: 'JS Basics',
      learningOutcome: 'Build full-stack dynamic web apps.'
    }
  },
  {
    title: 'Next.js 14',
    description: 'SSR, Full Stack with Edge Functions',
    category: 'Web',
    link: '#',
    details: {
      topics: ['SSR', 'Routing', 'API Routes'],
      duration: '4 weeks',
      prerequisites: 'React',
      learningOutcome: 'Create SEO-friendly full-stack apps with Next.js.'
    }
  },
  {
    title: 'Tailwind + Framer Motion',
    description: 'Modern UI + Animations',
    category: 'Web',
    link: '#',
    details: {
      topics: ['TailwindCSS', 'Framer Motion'],
      duration: '3 weeks',
      prerequisites: 'React',
      learningOutcome: 'Design responsive and animated UIs.'
    }
  },
  {
    title: 'Cloud Fundamentals',
    description: 'AWS, Azure, GCP basics',
    category: 'Cloud',
    link: '#',
    details: {
      topics: ['EC2', 'Storage', 'IAM'],
      duration: '5 weeks',
      prerequisites: 'None',
      learningOutcome: 'Understand key cloud concepts and services.'
    }
  },
  {
    title: 'Docker & Kubernetes',
    description: 'Containers + Orchestration',
    category: 'Cloud',
    link: '#',
    details: {
      topics: ['Dockerfiles', 'K8s Pods/Services'],
      duration: '5 weeks',
      prerequisites: 'Linux Basics',
      learningOutcome: 'Build and deploy containerized apps.'
    }
  },
  {
    title: 'CI/CD Pipelines',
    description: 'GitHub Actions, Jenkins',
    category: 'Cloud',
    link: '#',
    details: {
      topics: ['Build Automation', 'Testing', 'Deployment'],
      duration: '4 weeks',
      prerequisites: 'Git, Bash',
      learningOutcome: 'Automate app delivery pipelines.'
    }
  },
  {
    title: 'Ethical Hacking',
    description: 'Kali Linux, Metasploit, Nmap',
    category: 'Security',
    link: '#',
    details: {
      topics: ['Penetration Testing', 'Reconnaissance'],
      duration: '6 weeks',
      prerequisites: 'Networking Basics',
      learningOutcome: 'Perform vulnerability assessments.'
    }
  },
  {
    title: 'Flutter Apps',
    description: 'Cross-platform with Dart',
    category: 'Mobile',
    link: '#',
    details: {
      topics: ['Widgets', 'Navigation', 'State Mgmt'],
      duration: '5 weeks',
      prerequisites: 'OOP Concepts',
      learningOutcome: 'Develop cross-platform mobile apps.'
    }
  },
  {
    title: 'React Native',
    description: 'Hybrid Mobile Apps',
    category: 'Mobile',
    link: '#',
    details: {
      topics: ['Components', 'Navigation', 'APIs'],
      duration: '5 weeks',
      prerequisites: 'React Basics',
      learningOutcome: 'Build native-like apps with React Native.'
    }
  },
  {
    title: 'SQL + NoSQL',
    description: 'PostgreSQL, MongoDB',
    category: 'Data',
    link: '#',
    details: {
      topics: ['Joins', 'Indexes', 'Schemas'],
      duration: '4 weeks',
      prerequisites: 'None',
      learningOutcome: 'Work with relational and NoSQL databases.'
    }
  },
  {
    title: 'Power BI + Tableau',
    description: 'Business Intelligence Dashboards',
    category: 'Data',
    link: '#',
    details: {
      topics: ['Data Visuals', 'Dashboards', 'Reports'],
      duration: '3 weeks',
      prerequisites: 'Excel/Data Basics',
      learningOutcome: 'Build interactive dashboards for insights.'
    }
  },
  {
    title: 'Git & GitHub',
    description: 'Version Control for Teams',
    category: 'Tools',
    link: '#',
    details: {
      topics: ['Commits', 'Branches', 'Merge'],
      duration: '2 weeks',
      prerequisites: 'None',
      learningOutcome: 'Collaborate on code with Git workflows.'
    }
  },
  {
    title: 'VS Code + Extensions',
    description: 'Boost Coding Efficiency',
    category: 'Tools',
    link: '#',
    details: {
      topics: ['Shortcuts', 'Extensions', 'Settings'],
      duration: '1 week',
      prerequisites: 'None',
      learningOutcome: 'Customize VS Code for better productivity.'
    }
  }
];
function CoursesSection() {
  const [expandedCard, setExpandedCard] = useState(null);
  const [filter, setFilter] = useState('All');

  const handleToggle = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredCourses =
    filter === 'All'
      ? trendingCourses
      : trendingCourses.filter((course) => course.category === filter);

  const uniqueCategories = ['All', ...new Set(trendingCourses.map((course) => course.category))];

  return (
    <Box
      id="courses"
      sx={{
        py: 8,
        px: { xs: 2, sm: 4, md: 10 },
        background: 'radial-gradient(circle at top left, #112244, #0c1e3c)',
        color: '#fff'
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: '900',
          mb: 4,
          textAlign: 'center',
          background: 'linear-gradient(45deg, #ffcb05, #ffa500)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: 1.5
        }}
      >
        Trending Tech Courses (2025 Edition)
      </Typography>

      <Box sx={{ maxWidth: 250, mx: 'auto', mb: 6 }}>
        <FormControl
          fullWidth
          variant="outlined"
          sx={{ backgroundColor: '#1e1e1e', borderRadius: 2 }}
        >
          <InputLabel sx={{ color: '#ffcb05' }}>Filter by Category</InputLabel>
          <Select
            value={filter}
            onChange={handleFilterChange}
            label="Filter by Category"
            sx={{
              color: '#fff',
              '.MuiOutlinedInput-notchedOutline': { borderColor: '#ffcb05' }
            }}
          >
            {uniqueCategories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Grid container spacing={4}>
        {filteredCourses.map((course, index) => (
          <Grid item xs={12} sm={6} md={4} key={course.title}>
            <motion.div
              whileHover={{ scale: 1.05, rotate: 1 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
            >
              <Card
                onClick={() => handleToggle(index)}
                sx={{
                  background: 'rgba(255 255 255 / 0.1)',
                  border: '1px solid rgba(255, 203, 5, 0.3)',
                  borderRadius: 3,
                  cursor: 'pointer',
                  color: '#fff',
                  p: 2,
                  minHeight: '200px'
                }}
              >
                <Typography variant="h6" sx={{ color: '#ffcb05', fontWeight: 700 }}>
                  {course.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {course.description}
                </Typography>
                <Collapse in={expandedCard === index} timeout="auto" unmountOnExit>
                  <Box mt={2}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                      Topics:
                    </Typography>
                    <ul>
                      {course.details.topics.map((topic, idx) => (
                        <li key={idx}>{topic}</li>
                      ))}
                    </ul>
                    <Typography variant="body2">
                      <strong>Duration:</strong> {course.details.duration}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Prerequisites:</strong> {course.details.prerequisites}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      <strong>Outcome:</strong> {course.details.learningOutcome}
                    </Typography>
                    <Box mt={2}>
                      <Button
                        href={`https://wa.me/919949337308?text=Hi, I am interested in the "${course.title}" course from Spark AI Edutech. Please share more details.`}
                        target="_blank"
                        variant="contained"
                        sx={{
                          background: 'linear-gradient(45deg, #ffcb05, #ffa500)',
                          color: '#0c1e3c',
                          fontWeight: 'bold',
                          borderRadius: 2,
                          '&:hover': {
                            background: 'linear-gradient(45deg, #ffa500, #ffcb05)'
                          }
                        }}
                      >
                        Enroll Now
                      </Button>
                    </Box>
                  </Box>
                </Collapse>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default CoursesSection;
